export default "__VITE_PUBLIC_ASSET__5d636040__"